import { Button } from '@practium/ui';
import styles from './InfoCard.module.css';

interface InfoCardProps {
	title: string;
	subtitle: string;
	buttonText: string;
	onButtonClick: () => void;
	imageUrl?: string;
	decorativeStyle?: 'grid' | 'paper';
}

export const InfoCard = ({
	title,
	subtitle,
	buttonText,
	onButtonClick,
	imageUrl,
	decorativeStyle,
}: InfoCardProps) => {
	const cardClass = imageUrl ? styles.withImage : decorativeStyle ? styles.withDecorative : '';

	return (
		<div className={`${styles.card} ${cardClass}`}>
			{!imageUrl && decorativeStyle && (
				<div className={styles.decorativeContainer}>
					<div
						className={decorativeStyle === 'grid' ? styles.decorativeGrid : styles.decorativePaper}
					/>
				</div>
			)}
			<div className={styles.content}>
				<h3 className={styles.title}>{title}</h3>
				<p className={styles.subtitle}>{subtitle}</p>
				<Button variant="cardAction" className={styles.button} onClick={onButtonClick}>
					{buttonText}
				</Button>
			</div>
			{imageUrl && (
				<div className={styles.imageContainer}>
					<img src={imageUrl} alt={title} className={styles.image} />
				</div>
			)}
		</div>
	);
};
